module.exports = __webpack_public_path__ + "img/turkey.f1f148e8.jpg";